import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import i18n from 'i18next';

import './CreditguardIframe.scss';

// hack: this is a workaround for lack of redirect url usage
// the credit guard API supports it already but we don't use it yet
// previously the value was 2
const NUMBER_OF_TIMES_THE_IFRAME_LOADS_UNTIL_ITS_READY = 2

const CreditguardIframe = ({ onSubmit, iframeUrl, mpiTranId }) => {
    const [iframeLoads, setIframeLoads] = useState(1);
    const [showRetry, setShowRetry] = useState(false);
    const isLoading = useSelector(state => state.loading.queue.length > 0);

    const handleSubmit = () => {
        onSubmit(mpiTranId);
    };

    const handleIframeReload = () => {
        if (iframeLoads < NUMBER_OF_TIMES_THE_IFRAME_LOADS_UNTIL_ITS_READY) {
            setIframeLoads(iframeLoads + 1);
        } else {
            setShowRetry(true);
            handleSubmit();
        }
    };

    if (!showRetry && iframeUrl) {
        return (
            <iframe
                id="creditguard-iframe"
                title="creditGuard"
                src={iframeUrl}
                onLoad={handleIframeReload}
            />
        );
    }

    if (showRetry && !isLoading) {
        return (
            <div className="btn-retry">
                <Button
                    primary
                    onClick={handleSubmit}
                >
                    {i18n.t('general.retry')}
                </Button>
                <Button
                    onClick={() => window.location.reload()}
                >
                    {i18n.t('general.refillCardDetails')}
                </Button>
            </div>
        );
    }

    return null;
};

CreditguardIframe.propTypes = {
    onSubmit: PropTypes.func,
    iframeUrl: PropTypes.string,
    mpiTranId: PropTypes.string,
};

export default CreditguardIframe;
